// extracted by mini-css-extract-plugin
export var anchor = "section-downloadable-module--anchor--M6bzI";
export var container = "section-downloadable-module--container--wbR1a";
export var desc = "section-downloadable-module--desc--URtdj";
export var downloadableContainer = "section-downloadable-module--downloadable-container--ywbj6";
export var icon = "section-downloadable-module--icon--eJLEM";
export var title = "section-downloadable-module--title--vlbs0";